import { types } from 'mobx-state-tree'

const AuthStore = types
  .model('AuthStore', {
    authUser: types.maybeNull(types.frozen()),
    authUserProfile: types.maybeNull(types.frozen())
  })
  .views(self => ({
    get isAdminOrSuperAdmin() {
      return self.authUserProfile.role === 'admin' || self.authUserProfile.role === 'superadmin'
    }
  }))
  .actions(self => ({
    setAuthUser(authUser) {
      self.authUser = authUser
    },
    setAuthUserProfile(authUserProfile) {
      self.authUserProfile = authUserProfile
    }
  }))

export default AuthStore.create()
